<div class="page-wraper">

    <!-- HEADER START -->
    <app-header1></app-header1>
    <!-- HEADER END -->

    <!-- CONTENT START -->
    <div class="page-content">

        <!-- INNER PAGE BANNER -->
        <!-- <app-page-banner class="small-banner" title="About Us" subtitle="About Us"></app-page-banner> -->
        <!-- INNER PAGE BANNER END -->

        <!-- Project START -->
        <div class="section-full p-t10 p-b90 projects-outer-full mt-3">
            <div class="container">
                <!-- Section Title -->
                <div class="section-head center wt-small-separator-outer text-center text-white mb-4">
                    <!-- <h4>Psychotherapy Services
                    </h4> -->
                </div>

        
               
                <!-- Second Row (Content Left, Image Right) -->
                <!-- <div class="small-banner1" title="Our Mission" subtitle="Our Mission"><span class="sub-small-banner">Our Mission</span></div> -->
                 <div class="Space-banner">&nbsp;</div>
                 <div>&nbsp;</div>

                <!-- <div class="banner-title-outer">
                    <div class="banner-title-name">
                        <h4 style="color: #333;">Our Mission</h4>
                    </div>
                </div> -->

                <div class="row  mb-5">
                   
                    <div class="col-lg-12 col-md-12">
                        <app-page-banner class="small-banner1" title="School Mental Health Program" subtitle="School Mental Health Program"></app-page-banner>

                        </div>

                    <div class="col-lg-6 col-md-12">
                        <div class="about-content">
                            <h5>Program Overview</h5>
                            <p>Our Evidence based methodology for holistic wellness.</p>

                            <p><b>Techniques and methods used for evaluations & interventions</b></p>

                            <p>Psychological Evaluations:</p>
                           <ul class="centered-list">
                            <li>Use of scientifically validated tools and assessments.</li>
                            <li>Behavioral observations to identify patterns and triggers.</li>
                            <li>Structured interviews and surveys.</li>
                            <li>Comprehensive data gathering and analysis.</li>
                           </ul> 
                           

                            <p>Regular Interventions:</p>
                           <ul class="centered-list">
                            <li>Counseling sessions by trained psychologists.</li>
                            <li>Cognitive Behavioral Therapy (CBT).</li>
                            <li>Mindfulness and relaxation exercises.</li>
                            <li>Workshops on emotional regulation and seminars.</li></ul>
                            <!-- <p >
                                The School Mental Health Program at Soul Space is a 3-months comprehensive
                                initiative designed to support the overall well-being of students between the age of
                                12 to 17 years. The program, taking a holistic approach, goes beyond the classroom,
                                focusing on the mental, emotional, physical and social health of students to empower
                                them to thrive academically and personally.
                            </p> -->
                           
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-12">
                        <div class="about-image">
                            

                            <img src="assets/images/happy-football-children-relax-on-field-sports-port-2023-11-27-05-17-32-utc.jpg" alt="About Soul Space" class="img-fluid" style="
                            height: 400px;
                            width: 100%;

                        ">
                        </div>
                        <div class="schoolprogram">
                            <a routerLink="/school-program" class="btn btn-primary schoolprogramac">Read More</a>
                        </div>
                       
                        

                    </div>
                    
                </div>

                <!-- Third Row (Image Left, Content Right) -->
                <!-- <app-page-banner class="small-banner" title="Our Vision" subtitle="Our Vision"></app-page-banner> -->
                <!-- <div class="small-banner1" title="Our Vision" subtitle="Our Vision"><span class="sub-small-banner">Our Vision</span></div> -->



                <div class="row  mb-5">

                    <div class="col-lg-12 col-md-12">
                        <app-page-banner class="small-banner1" title="Women Wellness Program" subtitle="Women Wellness Program"></app-page-banner>

                        </div>
                  
                    <div class="col-lg-6 col-md-12">
                        <div class="about-content mobcontent">
                            <h5>Program Structure </h5>
                            <p>
                                Women Wellness Program at Soul Space is an initiative especially crafted to
                                empower women by addressing their overall well-being. The program nurtures
                                women’s emotional, physical, mental and social health providing them a safe and
                                supportive environment. This facilitates women to explore strategies to enhance their
        
                                health by rediscovering balance, building resilience and celebrating the strength
                                within.
                            </p>

                           
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-12">
                        <h6></h6>
                        <div class="about-image">
                            <img src="assets/images/multi-ethnic-group-of-confident-mature-women-bondi-2023-11-27-05-34-15-utc.jpg" alt="About Soul Space" class="img-fluid" style="
                            height: 400px;
                            width: 100%;
                        ">
                        </div>

                        <div class="schoolprogram1">
                            <a routerLink="/women-wellness" class="btn btn-primary schoolprogramac">Read More</a>
                        </div>

                      
                    </div>
                </div>

                <!-- Fourth Row (Content Left, Image Right) -->
                <!-- <div class="small-banner1" ><span class="sub-small-banner">Who are we?</span></div> -->


                <div class="row  mb-5 mt-5">
                    <div class="col-lg-12 col-md-12">
                        <app-page-banner class="small-banner1" title="Elderly Wellness Program" subtitle="Elderly Wellness Program"></app-page-banner>

                        </div>
                   
                    <div class="col-lg-6 col-md-12">
                        <div class="about-content mobcontent">
                            <h5>Program Structure </h5>
                            <p>
                                Elderly Wellness Program at Soul Space is a compassionate and engaging initiative
                                designed for elderly people or for the people above 60 years of age. Fostering the
                                physical, emotional, mental and social health of the seniors, the program aims to
                                enhance the overall wellbeing of elders, empowering them to lead fulfilling and
                                vibrant lives.
                            </p>
                          
                        </div>
                    </div>

                    <div class="col-lg-6 col-md-12">
                        <div class="about-image">
                            <img src="assets/images/origami-fun-2023-11-27-05-14-01-utc.jpg" alt="About Soul Space" class="img-fluid" style="
                            height: 400px;
                            width: 100%;
                        ">
                        </div>
                        <div class="schoolprogram1">
                            <a routerLink="/elderly-wellness" class="btn btn-primary schoolprogramac">Read More</a>
                        </div>
                    </div>
                </div>

             

            

           
              

                
               
               

            </div>

        </div>
    </div>

    <app-footer1></app-footer1>
</div>
<app-loader></app-loader>